




























import { Component, Vue, Prop, Watch, Ref } from 'vue-property-decorator';

@Component
export default class SElementValidationErrors extends Vue {
  @Prop({ required: true }) private errorMessages!: string[] | null;
  @Prop({ type: Boolean, required: true }) private focused?: boolean;

  public hovered = false;

  @Ref() public readonly popoverRef!: Vue;

  private get openPopup(): boolean {
    return !!(
      this.errorMessages &&
      this.errorMessages.length &&
      (this.focused || this.hovered)
    );
  }

  @Watch('openPopup')
  public showPopup() {
    const popup = (this.popoverRef.$refs.popover as HTMLElement);
    if (popup) {
      popup.style.visibility = this.openPopup ? 'visible' : 'hidden';
      popup.style.zIndex = this.hovered ? '2' : '1'; // Hovered should be displayed over focused
    }
  }
}
